<div class="alert ml-3 mr-3" [ngClass]="[alert?.getAlertType()]" *ngIf="alert?.isVisible()">
  {{alert?.getMessage() | translate}}
</div>
